import { string, object, array } from "yup";
import { messages } from "../../../../utils/messages";
import { ProductShape, currencyCode } from "./product";

// Export schema
export const productImpression = object()
  .shape({
    currencyCode,
    impressions: array()
      .of(
        object()
          .shape({
            ...ProductShape,
            list: string(),
          })
          .noUnknown(messages.NO_UNKNOWN)
      )
      .required("Product impression requires an array of products."),
  })
  .noUnknown(messages.NO_UNKNOWN);
